import {
  AfterViewInit, Component, Inject, OnDestroy,
  OnInit
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { Icon, IconService } from '../../../common/services';
import { ListParameters } from '@Services/base/daoService';
import { PaginationBase } from '@Common/widgets/general/pagination';
import { PubSubService } from '../../../common/services/pub-sub.service';
import { typeEvents } from '../../../common/enum/type-events';


@Component({
  selector: 'p8-bdc-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss']
})
export class IconComponent extends PaginationBase implements OnInit, OnDestroy, AfterViewInit {
  icons: Icon[];
  private _searchText = '';
  private sub: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IconComponent>,
    private iconService: IconService,
    private pubSubSvc: PubSubService
  ) {
    super();
    this.MAX_ITEMS = 120;
  }

  set searchText(text: string) {
    this._searchText = text.toLowerCase();
    this.page = 1;
    this.getIcons(this.page, this._searchText);
  }

  get searchText(): string {
    return this._searchText;
  }

  ngOnInit() {
    this.pubSubSvc.publish(typeEvents.loading, true);

    this.getIcons();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  getList(page: number) {
    this.getIcons(page);
  }

  getIcons(page: number = 1, text = this._searchText) {
    this.page = page;

    const parameters: ListParameters = {
      limit: this.MAX_ITEMS,
      offset: (page - 1) * this.MAX_ITEMS,

      sort: '',
      order: '',

      keyword: text,
      extraParams: null
    };

    this.sub = this.iconService.listItems(parameters).subscribe((data) => {
      this.icons = data.list;
      this.pagination = data;

      this.total = data.total;
      this.totalView = data.totalView;
    });
  }

  ngAfterViewInit(): void {
    this.pubSubSvc.publish(typeEvents.loading, false);
  }

  trackByFn(index, item) {
    return index;
  }

  addIcon(icon) {
    this.dialogRef.close(icon);
  }

  close() {
    this.dialogRef.close(null);
  }
}
